var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmodeEnter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m35.53,8.83l20.1,20.1v6.26l-20.1,20.1h-6.26l-20.1-20.1v-6.26L29.27,8.83h6.26m.99-2.4h-8.25L6.77,27.94v8.25l21.51,21.51h8.25l21.51-21.51v-8.25L36.53,6.43h0Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "22.48 33.48 32.4 33.48 38.19 16.8 22.48 33.48"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "42.32 30.65 32.4 30.65 26.61 47.33 42.32 30.65"
}))));
export default SvgEmodeEnter;